import React from 'react';
import { BsCheck } from 'react-icons/bs';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { useGetEtaiementsList, useDuplicateEtaiement } from '~/hooks/etaiements';
import styles from './duplicate-estimate.module.scss';

import {
  ErrorField,
  StyledSelect,
} from '~/lib/HooksFormFields';

const DuplicateEtaiement = ({
  clientId,
  etaiementId,
  close,
} : {
  clientId?: string,
  etaiementId?: string,
  close: () => void,
}) => {
  const navigate = useNavigate();
  const { control, handleSubmit, formState: { errors } } = useForm<any>({
    defaultValues: {
      etaiementId,
      clientId,
    },
  });
  const { data: list = {} } = useGetEtaiementsList();
  const {
    isLoading,
    mutateAsync: duplicateEtaiement,
  } = useDuplicateEtaiement();

  const {
    clients = [],
  } = list;

  const submit = async (data: { etaiementId?: string; clientId?: string }) => {
    const resolvedClientId = data.clientId;
    if (!resolvedClientId) return;
    try {
      const { etaiement } = await duplicateEtaiement({
        etaiementId: data.etaiementId || etaiementId || '',
        clientId: resolvedClientId,
      });
      navigate(`/etaiements/${etaiement?._id}`);
      close();
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <div className={styles.form}>
      <h3>Dupliquer le devis</h3>
      <div className={styles.fields}>
        <div className={styles.containerField}>
          <StyledSelect
            name='clientId'
            label='Choisir un client'
            control={control}
            options={clients}
            isSearchable
            rules={{
              required: 'le client est requis',
            }}
          />

          {errors.clientId?.message && <ErrorField message={errors.clientId?.message}/>}
        </div>
      </div>
      <div className={styles.buttons}>
        <button className='invisible' onClick={() => close()}>Annuler</button>
        <button disabled={isLoading} onClick={handleSubmit(submit)}>
          <span className='icon'>{BsCheck({})}</span>
          <span>Valider</span>
        </button>
      </div>
    </div>
  );
};

export default DuplicateEtaiement;
